import AddCircleOutlinedIcon from '@mui/icons-material/AddCircleOutlined';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import {IconButton, Tooltip} from '@mui/material';
import {grey} from '@mui/material/colors';
import {bool, func, string} from 'prop-types';

import useCreateReportOrWorkspaceButton from '../../hooks/components/useCreateReportOrWorkspaceButton';
import usePayment from '../../hooks/providers/usePayment';
import Button from '../form/buttons/Button/Button';

// eslint-disable-next-line complexity
const CreateReportOrWorkspaceButton = ({maxLimitReached, disabled = false, onClick, tooltipTitle, label, size = 'small'}) => {
  const {
    responsive,
    handleClick,
    tooltipTitle: updatedTooltipTitle
  } = useCreateReportOrWorkspaceButton({
    maxLimitReached,
    onClick,
    tooltipTitle
  });
  const {isGuest} = usePayment();

  if (isGuest) return null;

  const disabledStyle = {
    border: `2px solid ${grey[500]} !important`,
    background: 'white !important',
    color: `${grey[500]} !important`
  };

  if (responsive) {
    return (
      <Tooltip placement="left-end" enterTouchDelay={100} title={updatedTooltipTitle}>
        <span>
          <IconButton disabled={maxLimitReached || disabled} sx={{mr: 1.5}} onClick={handleClick} edge="end" aria-label={label}>
            <AddCircleOutlinedIcon sx={{fontSize: 30}} color={maxLimitReached || disabled ? 'inherit' : 'primary'} />
          </IconButton>
        </span>
      </Tooltip>
    );
  }

  return (
    <Button
      hasTooltip
      tooltip={updatedTooltipTitle}
      size={size}
      onClick={handleClick}
      disabled={maxLimitReached || disabled}
      startIcon={<AddRoundedIcon />}
      color={maxLimitReached ? 'inherit' : 'primary'}
      variant={maxLimitReached ? 'contained' : 'outlined'}
      sx={{
        whiteSpace: 'nowrap',
        mr: 1,
        background: 'white',
        ...((maxLimitReached || disabled) && disabledStyle)
      }}
    >
      {label}
    </Button>
  );
};

CreateReportOrWorkspaceButton.propTypes = {
  // eslint-disable-next-line react/boolean-prop-naming
  disabled: bool,
  maxLimitReached: bool.isRequired,
  onClick: func,
  tooltipTitle: string.isRequired,
  label: string.isRequired,
  size: string
};

export default CreateReportOrWorkspaceButton;
